"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    appearances: function() {
        return appearances;
    },
    productions: function() {
        return productions;
    },
    segments: function() {
        return segments;
    }
});
const productions = [
    {
        "id": "wrestlemania-night-1",
        "backgroundColor": "#081f2a",
        "brandIds": [
            "raw",
            "smackdown"
        ],
        "color": "#fff",
        "date": "Sat Apr 06 2024 00:00:00 GMT+0100 (British Summer Time)",
        "image": "//www.wwe.com/f/styles/wwe_show_logo_xl/public/all/2024/02/WrestleMania_40_Primary_Logo_Black_Background--8ad98c026d72b44c42753d8e0ed18261.png",
        "name": "Wrestlemania Night 1",
        "cost": 300000,
        "segmentIds": [
            "lujur8w5",
            "lujur8w7",
            "lujur8w9",
            "lujur8wb",
            "lujur8wd",
            "lujurh6a",
            "lujux8a0"
        ],
        "showId": "Wrestlemania-night-1",
        "desc": "",
        "venueId": "DEFAULT",
        "complete": false
    },
    {
        "id": "wrestlemania-night-2",
        "backgroundColor": "#081f2a",
        "brandIds": [
            "raw",
            "smackdown"
        ],
        "color": "#fff",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "image": "//www.wwe.com/f/styles/wwe_show_logo_xl/public/all/2024/02/WrestleMania_40_Primary_Logo_Black_Background--8ad98c026d72b44c42753d8e0ed18261.png",
        "name": "Wrestlemania Night 2",
        "cost": 300000,
        "segmentIds": [
            "lujuyqhb",
            "lujuyqhe",
            "lujuyqhj",
            "lujuyqhh",
            "lujuyqhl",
            "lujuyqho",
            "lujva6qi",
            "lujuyqz1",
            "lujuyqz6",
            "lujuyqzi",
            "lujuyqze",
            "lujuyqza"
        ],
        "showId": "Wrestlemania-night-2",
        "desc": "",
        "venueId": "DEFAULT",
        "complete": false
    }
];
const segments = [
    {
        "id": "lujur8w0",
        "cost": 5000,
        "type": "INTRODUCTION",
        "name": "",
        "date": "Sat Apr 06 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujur8w5",
        "cost": 10000,
        "type": "DEFAULT",
        "name": "",
        "date": "Sat Apr 06 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujur8w7",
        "cost": 10000,
        "type": "DEFAULT",
        "name": "",
        "date": "Sat Apr 06 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujur8w9",
        "cost": 10000,
        "type": "DEFAULT",
        "name": "",
        "date": "Sat Apr 06 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujur8wb",
        "cost": 10000,
        "type": "TITLE_MATCH",
        "name": "",
        "date": "Sat Apr 06 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [
            "ic"
        ],
        "duration": 1800,
        "complete": false
    },
    {
        "id": "lujur8wd",
        "cost": 10000,
        "type": "TITLE_MATCH",
        "name": "",
        "date": "Sat Apr 06 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [
            "womens-world-championship"
        ],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujurh6a",
        "cost": 10000,
        "type": "DEFAULT",
        "name": "",
        "date": "Sat Apr 06 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujux8a0",
        "cost": 5000,
        "productionId": "lujun0wy",
        "type": "RECAP",
        "name": "",
        "desc": "",
        "date": "2024-04-03T13:41:52.297Z",
        "duration": 180,
        "complete": false,
        "rating": 0
    },
    {
        "id": "lujuyqhb",
        "cost": 200000,
        "type": "PYRO",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujuyqhe",
        "cost": 20000,
        "type": "SHOW_OPENING_VIDEO",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujuyqhh",
        "cost": 10000,
        "type": "TITLE_MATCH",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [
            "world-heavyweight"
        ],
        "duration": 1800,
        "complete": false
    },
    {
        "id": "lujuyqhj",
        "cost": 10000,
        "type": "DEFAULT",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujuyqhl",
        "cost": 10000,
        "type": "DEFAULT",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujuyqho",
        "cost": 10000,
        "type": "TITLE_MATCH",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [
            "us"
        ],
        "duration": 1800,
        "complete": false
    },
    {
        "id": "lujuyqz1",
        "cost": 10000,
        "type": "TITLE_MATCH",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [
            "wwe-title",
            "uni-world"
        ],
        "duration": 3600,
        "complete": false,
        "feudId": "rr-cr"
    },
    {
        "id": "lujuyqz6",
        "cost": 200000,
        "type": "PYRO",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujuyqza",
        "cost": 200000,
        "type": "PRESS_CONFERENCE",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujuyqze",
        "cost": 5000,
        "type": "RECAP",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujuyqzi",
        "cost": 100000,
        "type": "CHAMPIONSHIP_CELEBRATION",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [],
        "duration": 180,
        "complete": false
    },
    {
        "id": "lujva6qi",
        "cost": 10000,
        "type": "TITLE_MATCH",
        "name": "",
        "date": "Sun Apr 07 2024 00:00:00 GMT+0100 (British Summer Time)",
        "championshipIds": [
            "womens-championship"
        ],
        "duration": 900,
        "complete": false
    }
];
const appearances = [
    {
        "segmentId": "lujur8w5",
        "groupId": "lujurnql",
        "wrestlerId": "dragon-lee",
        "id": 0
    },
    {
        "segmentId": "lujur8w5",
        "groupId": "lujurs9s",
        "wrestlerId": "santos-escobar",
        "id": 1
    },
    {
        "segmentId": "lujur8w5",
        "groupId": "lujurs9s",
        "wrestlerId": "dominik-mysterio",
        "id": 3
    },
    {
        "segmentId": "lujur8w5",
        "groupId": "lujurnql",
        "wrestlerId": "rey-mysterio",
        "id": 4
    },
    {
        "segmentId": "lujur8w7",
        "groupId": "lujuso9o",
        "wrestlerId": "bianca-belair",
        "id": 5
    },
    {
        "segmentId": "lujur8w7",
        "groupId": "lujuso9o",
        "wrestlerId": "naomi",
        "id": 505
    },
    {
        "segmentId": "lujur8w7",
        "groupId": "lujussq0",
        "wrestlerId": "asuka",
        "id": 6
    },
    {
        "segmentId": "lujur8w7",
        "groupId": "lujuso9o",
        "wrestlerId": "jade-cargill",
        "id": 7
    },
    {
        "segmentId": "lujur8w7",
        "groupId": "lujussq0",
        "wrestlerId": "kairi-sane",
        "id": 8
    },
    {
        "segmentId": "lujur8w7",
        "groupId": "lujussq0",
        "wrestlerId": "dakota-kai",
        "id": 9
    },
    {
        "segmentId": "lujur8w9",
        "groupId": "lujutonx",
        "wrestlerId": "jey-uso",
        "id": 10
    },
    {
        "segmentId": "lujur8w9",
        "groupId": "lujutuie",
        "wrestlerId": "jimmy-uso",
        "id": 11
    },
    {
        "segmentId": "lujur8wb",
        "groupId": "lujutzfi",
        "wrestlerId": "gunther",
        "id": 12
    },
    {
        "segmentId": "lujur8wb",
        "groupId": "lujuu53f",
        "wrestlerId": "sami-zayn",
        "id": 13
    },
    {
        "segmentId": "lujur8wd",
        "groupId": "lujuureh",
        "wrestlerId": "becky-lynch",
        "id": 14
    },
    {
        "segmentId": "lujur8wd",
        "groupId": "lujuuucq",
        "wrestlerId": "rhea-ripley",
        "id": 15
    },
    {
        "segmentId": "lujurh6a",
        "groupId": "lujuvaap",
        "wrestlerId": "roman-reigns",
        "id": 16
    },
    {
        "segmentId": "lujurh6a",
        "groupId": "lujuvcxn",
        "wrestlerId": "cody-rhodes",
        "id": 17
    },
    {
        "segmentId": "lujurh6a",
        "groupId": "lujuvcxn",
        "wrestlerId": "seth-rollins",
        "id": 18
    },
    {
        "segmentId": "lujurh6a",
        "groupId": "lujuvaap",
        "wrestlerId": "the-rock",
        "id": 19
    },
    {
        "segmentId": "lujuyqhh",
        "groupId": "lujuzdbc",
        "wrestlerId": "seth-rollins",
        "id": 20
    },
    {
        "segmentId": "lujuyqhh",
        "groupId": "lujuziip",
        "wrestlerId": "drew-mcintyre",
        "id": 21
    },
    {
        "segmentId": "lujuyqhj",
        "groupId": "lujv2tlx",
        "wrestlerId": "bobby-lashley",
        "id": 22
    },
    {
        "segmentId": "lujuyqhj",
        "groupId": "lujv30ku",
        "wrestlerId": "karrion-kross",
        "id": 23
    },
    {
        "segmentId": "lujuyqhj",
        "groupId": "lujv30ku",
        "wrestlerId": "akam",
        "id": 24
    },
    {
        "segmentId": "lujuyqhj",
        "groupId": "lujv30ku",
        "wrestlerId": "rezar",
        "id": 25
    },
    {
        "segmentId": "lujuyqhj",
        "groupId": "lujv2tlx",
        "wrestlerId": "montez-ford",
        "id": 26
    },
    {
        "segmentId": "lujuyqhj",
        "groupId": "lujv2tlx",
        "wrestlerId": "angelo-dawkins",
        "id": 27
    },
    {
        "segmentId": "lujuyqhl",
        "groupId": "lujv46c5",
        "wrestlerId": "la-knight",
        "id": 28
    },
    {
        "segmentId": "lujuyqhl",
        "groupId": "lujv4c81",
        "wrestlerId": "aj-styles",
        "id": 29
    },
    {
        "segmentId": "lujuyqho",
        "groupId": "lujv4hq5",
        "wrestlerId": "logan-paul",
        "id": 30
    },
    {
        "segmentId": "lujuyqho",
        "groupId": "lujv4nwm",
        "wrestlerId": "kevin-owens",
        "id": 31
    },
    {
        "segmentId": "lujuyqho",
        "groupId": "lujv4qon",
        "wrestlerId": "randy-orton",
        "id": 32
    },
    {
        "segmentId": "lujuyqz1",
        "groupId": "lujv5i1v",
        "wrestlerId": "roman-reigns",
        "id": 33
    },
    {
        "segmentId": "lujuyqz1",
        "groupId": "lujv5i1v",
        "wrestlerId": "paul-heyman",
        "manager": true,
        "id": 303
    },
    {
        "segmentId": "lujuyqz1",
        "groupId": "lujv5o4v",
        "wrestlerId": "cody-rhodes",
        "id": 34
    },
    {
        "segmentId": "lujva6qi",
        "groupId": "lujvadn4",
        "wrestlerId": "bayley",
        "id": 35
    },
    {
        "segmentId": "lujva6qi",
        "groupId": "lujvamkr",
        "wrestlerId": "iyo-sky",
        "id": 36
    }
];
